module.exports = __webpack_public_path__ + "contents/menu/images/otukuri-poster.jpg?20eb706d30253df3b5ea60c35639da2f";